/* ArdanShield v8: responsive footer and progressive control enhancements. */
(() => {
  'use strict';

  const mobileFooter = window.matchMedia('(max-width: 798px)');

  function setFooterState(group, expanded) {
    const trigger = group.querySelector('[data-footer-group-trigger]');
    const panel = group.querySelector('[data-footer-group-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', String(expanded));
    panel.hidden = mobileFooter.matches ? !expanded : false;
  }

  function initialiseFooter(scope = document) {
    scope.querySelectorAll('[data-footer-group]').forEach(group => {
      const trigger = group.querySelector('[data-footer-group-trigger]');
      if (!trigger || trigger.dataset.asFooterReady === 'true') return;
      trigger.dataset.asFooterReady = 'true';
      setFooterState(group, false);
      trigger.addEventListener('click', () => {
        setFooterState(group, trigger.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function resetFooterForBreakpoint() {
    document.querySelectorAll('[data-footer-group]').forEach(group => setFooterState(group, false));
  }

  function initialiseAdaptiveOptions(scope = document) {
    scope.querySelectorAll('[data-adaptive-option-select]').forEach(select => {
      if (select.dataset.asOptionReady === 'true') return;
      select.dataset.asOptionReady = 'true';
      const optionGroup = select.closest('[data-option-index]');
      const form = select.closest('[data-product-form]');
      const optionIndex = Number(optionGroup && optionGroup.dataset.optionIndex);
      if (!form || Number.isNaN(optionIndex)) return;
      select.addEventListener('change', () => {
        const selector = form.querySelectorAll('.single-option-selector')[optionIndex];
        if (!selector) return;
        selector.value = select.value;
        selector.dispatchEvent(new Event('change', { bubbles: true }));
      });
      form.addEventListener('change', event => {
        if (!event.target.matches('.single-option-selector')) return;
        const selectors = [...form.querySelectorAll('.single-option-selector')];
        if (selectors.indexOf(event.target) === optionIndex) select.value = event.target.value;
      });
    });
  }

  function initialiseSearchClear(scope = document) {
    scope.querySelectorAll('.search-form').forEach(form => {
      const input = form.querySelector('[data-search-input]');
      const clear = form.querySelector('[data-search-clear]');
      if (!input || !clear || clear.dataset.asClearReady === 'true') return;
      clear.dataset.asClearReady = 'true';
      const update = () => { clear.hidden = input.value.length === 0; };
      input.addEventListener('input', update);
      clear.addEventListener('click', () => {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      update();
    });
  }

  function initialise(scope = document) {
    initialiseFooter(scope);
    initialiseAdaptiveOptions(scope);
    initialiseSearchClear(scope);
  }

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  if (mobileFooter.addEventListener) mobileFooter.addEventListener('change', resetFooterForBreakpoint);
  else mobileFooter.addListener(resetFooterForBreakpoint);
})();
